import { _ as P, a as E, b as le, c as M, d as fe } from "./TermsModal-CU97WVqy.js";
import { e as Xt, f as Gt, g as Jt, h as Qt, i as Zt, j as en, k as tn, l as nn, m as on, n as an, o as rn } from "./TermsModal-CU97WVqy.js";
import { defineComponent as h, resolveComponent as C, unref as p, openBlock as c, createBlock as f, createSlots as A, withCtx as v, createVNode as m, createCommentVNode as k, computed as u, createElementBlock as y, Fragment as K, createElementVNode as _, toValue as be, defineAsyncComponent as T, resolveDynamicComponent as _e, createTextVNode as I, toDisplayString as w, renderSlot as b, renderList as L, watch as D, normalizeProps as he, guardReactiveProps as ke, useModel as B, nextTick as ge, onMounted as xe, mergeModels as V, normalizeClass as F, withDirectives as we, vModelRadio as Ce, ref as se, withModifiers as $e } from "vue";
import { useProviderI18n as x, extractProviderKey as Pe, useApplicationStore as R, usePaymentPlanService as De, reportSessionError as Ke, formatLocalDate as Se, fullDaysBetween as Ie, useFieldStore as Me, useProviderStore as ce } from "@versatile-credit-apply/sdk";
import { mapValues as Ae } from "lodash-es";
import { useI18n as Te } from "vue-i18n";
import { useIsInStore as Le } from "@versatile-credit-apply/composition";
import { A as sn, _ as cn, T as un, V as dn } from "./index-BGA6AVuH.js";
import { useDebounceFn as Be } from "@vueuse/core";
import { _ as ue } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { useScopedRegle as Ve } from "@regle/core";
import { requiredIf as Re } from "@regle/rules";
import { faCircleCheck as Ee, faCircle as Fe } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as q } from "@fortawesome/vue-fontawesome";
import qe from "@ui-kit/components/button";
import Ne from "@ui-kit/components/drawer";
import { useRoute as de } from "vue-router";
import { _ as mn } from "./TermsModalLink-CKLFnTot.js";
const S = /* @__PURE__ */ h({
  __name: "DisclosureContact",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { te: n } = x(() => e.providerKey);
    return (o, r) => {
      const a = C("i18n-t");
      return p(n)("contact") ? (c(), f(a, {
        key: 0,
        keypath: "contact",
        tag: "p"
      }, A({ _: 2 }, [
        t.providerKey ? {
          name: "lender",
          fn: v(() => [
            m(P, { "provider-key": t.providerKey }, null, 8, ["provider-key"])
          ]),
          key: "0"
        } : void 0,
        t.providerKey ? {
          name: "lenderLong",
          fn: v(() => [
            m(P, {
              "provider-key": t.providerKey,
              "display-type": "long"
            }, null, 8, ["provider-key"])
          ]),
          key: "1"
        } : void 0,
        t.providerKey ? {
          name: "website",
          fn: v(() => [
            m(a, {
              keypath: "contact_website",
              tag: "span"
            })
          ]),
          key: "2"
        } : void 0,
        t.providerKey ? {
          name: "bankDefault",
          fn: v(() => [
            m(p(E), { "provider-key": t.providerKey }, null, 8, ["provider-key"])
          ]),
          key: "3"
        } : void 0,
        t.providerKey ? {
          name: "bankShort",
          fn: v(() => [
            m(p(E), {
              "provider-key": t.providerKey,
              "display-type": "short"
            }, null, 8, ["provider-key"])
          ]),
          key: "4"
        } : void 0
      ]), 1024)) : k("", !0);
    };
  }
});
function N(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "You authorize " }, { t: 4, k: "lender" }, { t: 3, v: " to contact you at each mobile number you have provided. By providing a mobile number you agree to receive 1) account updates and information and 2) account security alerts, including text messages from " }, { t: 4, k: "lender" }, { t: 3, v: ". Message frequency varies. Message & data rates may apply. Text HELP for help, text STOP to Opt-Out. Terms & Conditions and Privacy Policy: " }, { t: 4, k: "website" }, { t: 3, v: `.
` }] } },
      contact_website: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "www.synchrony.com" } }
    }
  });
}
function O(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "When you give us your mobile phone number, we have your permission to contact you at that number about all of your " }, { t: 4, k: "lenderLong" }, { t: 3, v: ` accounts. Your consent allows us to use text messaging, artificial or pre-recorded voice messages and automatic dialling technology for informational and account service calls, but not for telemarketing or sales calls. It may include contact from companies working on our behalf to service your accounts. Message and data rates may apply. You may contact us anytime to change these preferences.
` }] } }
    }
  });
}
function Y(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      contact: { t: 0, b: { t: 2, i: [{ t: 3, v: "By providing a mobile number or a number later converted to a mobile number, you agree that " }, { t: 4, k: "bankShort" }, { t: 3, v: ", " }, { t: 4, k: "bankDefault" }, { t: 3, v: ` and their service providers may contact you regarding your accounts at that number, including by autodialer, recorded or artificial voice, and text. Message and data rates may apply.
` }] } }
    }
  });
}
typeof N == "function" && N(S);
typeof O == "function" && O(S);
typeof Y == "function" && Y(S);
const g = /* @__PURE__ */ h({
  __name: "DisclosureIncome",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { te: n } = x(() => e.providerKey), o = u(
      () => n(`${e.vertical}.income`) ? `${e.vertical}.income` : "income"
    );
    return (r, a) => {
      const l = C("i18n-t");
      return c(), y(K, null, [
        m(l, {
          keypath: o.value,
          tag: "p"
        }, A({
          wi_note: v(() => [
            m(l, {
              tag: "span",
              class: "font-medium",
              keypath: "wi_note"
            })
          ]),
          wi_disclaimer: v(() => [
            m(l, {
              tag: "span",
              keypath: "wi_disclaimer"
            })
          ]),
          br: v(() => [
            a[0] || (a[0] = _("br", null, null, -1))
          ]),
          _: 2
        }, [
          t.providerKey ? {
            name: "lender",
            fn: v(() => [
              m(P, { "provider-key": t.providerKey }, null, 8, ["provider-key"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["keypath"]),
        p(n)("income_line_2") ? (c(), f(l, {
          key: 0,
          class: "font-bold",
          keypath: "income_line_2",
          tag: "p"
        }, {
          wi_disclaimer: v(() => [
            m(l, {
              class: "font-normal",
              keypath: "wi_disclaimer",
              tag: "span"
            })
          ]),
          _: 1
        })) : k("", !0)
      ], 64);
    };
  }
});
function j(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. " }, { t: 4, k: "wi_note" }, { t: 3, v: " " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: `
` }] } },
      wi_disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `If you are applying for an individual account and your spouse also is a WI resident, combine your and your spouse's financial information.
` } },
      wi_note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `MARRIED WI Residents only:
` } }
    }
  });
}
function z(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation.
` } }
    }
  });
}
function H(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "easypay_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. For information regarding " }, { t: 4, k: "lender" }, { t: 3, v: `'s Programs, visit www.easypayfinance.com/programs.
` }] } }
    }
  });
}
function W(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "snap_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if you do not wish to have it considered as a basis for repaying this obligation. If you include non-taxable income/benefits, increase them by 20%.
` } }
    }
  });
}
function U(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "synchrony_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3, v: 'Your "Monthly Net Income" includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit. ' }, { t: 4, k: "wi_note" }, { t: 3, v: `: If this is an individual account, please also include your spouse’s income.
` }] } },
      wi_note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI Residents Only" } }
    }
  });
}
function X(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "progressive_standard_en",
    resource: {
      income: { t: 0, b: { static: "", t: 2, i: [] } }
    }
  });
}
function G(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "fortiva_standard_dell_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `*Alimony; child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation.
` } },
      income_line_2: { t: 0, b: { t: 2, i: [{ t: 3, v: "Wisconsin Married Residents: " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: `
` }] } },
      wi_disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Combine your and your spouse's information." } }
    }
  });
}
function J(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      income: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Alimony, child support, or separate maintenance income need not be revealed if  you do not wish to have it considered as a basis for repaying your obligation. Your total gross annual income is what you earn or reasonably expect to earn  from work, self-employment, interest, dividends, investments, social security  or other benefits. You can also include money that someone else regularly  deposits into your banking account and if you are 21 or older you can include  income from others that you regularly use to pay your bills.
` } }
    }
  });
}
function Q(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "ads_standard_en",
    resource: {
      retail: {
        income: { t: 0, b: { t: 2, i: [{ t: 3, v: "Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. " }, { t: 4, k: "wi_note" }, { t: 3, v: " " }, { t: 4, k: "wi_disclaimer" }, { t: 3, v: " " }, { t: 4, k: "br" }, { t: 3, v: " " }, { t: 4, k: "br" }, { t: 3, v: ` Income is not provided to all lenders until you decide to proceed with a full application.
` }] } }
      }
    }
  });
}
typeof j == "function" && j(g);
typeof z == "function" && z(g);
typeof H == "function" && H(g);
typeof W == "function" && W(g);
typeof U == "function" && U(g);
typeof X == "function" && X(g);
typeof G == "function" && G(g);
typeof J == "function" && J(g);
typeof Q == "function" && Q(g);
const pe = /* @__PURE__ */ h({
  __name: "DisclosureBankCard",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { te: n } = x(() => e.providerKey);
    return (o, r) => {
      const a = C("i18n-t");
      return p(n)("bank_card") ? (c(), f(a, {
        key: 0,
        keypath: "bank_card",
        tag: "p"
      })) : k("", !0);
    };
  }
});
function Z(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "aff_standard_en",
    resource: {
      bank_card: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Prepaid cards are not accepted.
` } }
    }
  });
}
typeof Z == "function" && Z(pe);
const Oe = (t) => {
  const e = be(t);
  if (e == null)
    return;
  const n = typeof e == "string" ? e : e.providerKey;
  return n != null ? Pe(n) : void 0;
}, Ye = (t, e) => {
  const n = Ae(
    e,
    (o) => T(o)
  );
  return u(() => {
    const o = Oe(t);
    return o ? n[o] : void 0;
  });
}, je = /* @__PURE__ */ h({
  __name: "DisclosurePrequalify",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, n = Ye(() => e.providerKey, {
      synchrony_standard: () => import("./SynchronyDisclosurePrequalify-B9c1irnQ.js"),
      ads_standard: () => import("./AdsDisclosurePrequalify-B7SwvuzP.js"),
      snap_standard: () => import("./SnapDisclosurePrequalify-CFLW9fPC.js")
    });
    return (o, r) => (c(), f(_e(p(n)), { "provider-key": t.providerKey }, null, 8, ["provider-key"]));
  }
}), ze = ["href"], me = /* @__PURE__ */ h({
  __name: "DisclosureContactFooter",
  props: {
    providerKey: {},
    applyMode: {},
    vertical: {}
  },
  setup(t) {
    const e = t, { t: n, te: o } = x(() => e.providerKey), r = R(), a = u(
      () => o("actions.prequalify.next") ? n("actions.prequalify.next") : n("actions.next")
    ), l = u(() => {
      const i = r.application?.primary?.mobilePhone ?? "XXXX";
      return i.length > 4 ? i.substring(i.length - 4) : i;
    });
    return (i, s) => {
      const d = C("i18n-t");
      return p(o)("footer") ? (c(), f(d, {
        key: 0,
        class: "px-1 pt-8 text-sm",
        keypath: "footer",
        tag: "p"
      }, A({
        next: v(() => [
          I(w(a.value), 1)
        ]),
        phoneLast4: v(() => [
          I(w(l.value), 1)
        ]),
        _: 2
      }, [
        t.providerKey ? {
          name: "link",
          fn: v(() => [
            p(o)("link") ? (c(), y("a", {
              key: 0,
              class: "text-primary-600",
              href: p(n)("link"),
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              m(d, { keypath: "link_label" })
            ], 8, ze)) : k("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1024)) : k("", !0);
    };
  }
});
function ee(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "katapult_standard_en",
    resource: {
      footer: { t: 0, b: { t: 2, i: [{ t: 3, v: 'By clicking "' }, { t: 4, k: "next" }, { t: 3, v: '", you accept the terms of our ' }, { t: 4, k: "link" }, { t: 3, v: " and consent to receiving a one-time passcode sent to the phone number ending in " }, { t: 4, k: "phoneLast4" }, { t: 3, v: `.
` }] } },
      link: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://katapult.com/app/privacy-policy" } },
      link_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Privacy Policy" } }
    }
  });
}
typeof ee == "function" && ee(me);
const He = { key: 0 }, qt = /* @__PURE__ */ h({
  __name: "DisclosureDictionary",
  props: {
    providerKey: {},
    type: {},
    applyMode: { default: "full" },
    vertical: {}
  },
  setup(t) {
    const e = t, n = u(() => e.type === "contact"), o = u(() => e.type === "income"), r = u(() => e.type === "bank-card"), a = u(() => e.type === "contact-footer"), l = u(
      () => e.type === "prequalify-disclosure" && e.applyMode == "prequalify"
    ), i = u(
      () => n.value || o.value || r.value || l.value || a.value
    ), s = u(() => e.applyMode ?? "full");
    return (d, $) => i.value ? (c(), y("div", He, [
      b(d.$slots, "footnote"),
      n.value ? (c(), f(S, {
        key: 0,
        "provider-key": t.providerKey,
        "apply-mode": s.value
      }, null, 8, ["provider-key", "apply-mode"])) : o.value ? (c(), f(g, {
        key: 1,
        "provider-key": t.providerKey,
        "apply-mode": s.value,
        vertical: t.vertical
      }, null, 8, ["provider-key", "apply-mode", "vertical"])) : r.value ? (c(), f(pe, {
        key: 2,
        "provider-key": t.providerKey,
        "apply-mode": s.value
      }, null, 8, ["provider-key", "apply-mode"])) : l.value ? (c(), f(je, {
        key: 3,
        "provider-key": t.providerKey,
        "apply-mode": s.value
      }, null, 8, ["provider-key", "apply-mode"])) : k("", !0),
      a.value ? (c(), f(me, {
        key: 4,
        "provider-key": t.providerKey,
        "apply-mode": s.value
      }, null, 8, ["provider-key", "apply-mode"])) : k("", !0)
    ])) : k("", !0);
  }
}), We = { class: "contents" }, Ue = { class: "font-medium sm:justify-self-end" }, Xe = /* @__PURE__ */ h({
  __name: "ErrorDetailsField",
  props: {
    label: {},
    value: {}
  },
  setup(t) {
    return (e, n) => (c(), y("div", We, [
      _("div", Ue, w(t.label) + ":", 1),
      _("div", null, w(t.value), 1)
    ]));
  }
}), Ge = {
  key: 0,
  class: "grid grid-cols-1 justify-start gap-3 p-2 sm:p-4 bg-surface-100 text-sm border-gray-300 text-gray-600 sm:grid-cols-[max-content_1fr] rounded-lg border"
}, Je = /* @__PURE__ */ h({
  __name: "ErrorDetails",
  props: {
    error: {}
  },
  setup(t) {
    const { t: e } = Te(), n = t, o = Le(), r = u(() => {
      const a = [];
      return n.error?.trackingId && a.push({
        label: e("errors.field.tracking_id.label"),
        value: n.error.trackingId
      }), o.value && n.error?.code && a.push({
        label: e("errors.field.code.label"),
        value: n.error.code
      }), o.value && n.error?.details && a.push({
        label: e("errors.field.details.label"),
        value: n.error.details
      }), a;
    });
    return (a, l) => r.value.length ? (c(), y("div", Ge, [
      (c(!0), y(K, null, L(r.value, (i, s) => (c(), f(Xe, {
        key: s,
        label: i.label,
        value: i.value
      }, null, 8, ["label", "value"]))), 128))
    ])) : k("", !0);
  }
});
function te(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      errors: {
        field: {
          code: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Code" } }
          },
          details: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Error Details" } }
          },
          tracking_id: {
            label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tracking ID" } }
          }
        },
        general: {
          instructions: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please contact your " }, { t: 4, k: "merchantName" }, { t: 3, v: " associate." }] } },
          title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "An unexpected error occurred." } }
        }
      }
    }
  });
}
typeof te == "function" && te(Je);
const Nt = T(
  () => import("./ModalLauncherButton-BmkRuq_k.js")
), Ot = T(
  () => import("./ConfirmExitFlowButton-CrsxcGA2.js")
), Qe = { class: "text-center" }, ve = /* @__PURE__ */ h({
  __name: "PlanSummaryTab",
  props: {
    offer: {},
    vertical: {},
    active: { type: Boolean }
  },
  setup(t) {
    const e = t, n = u(() => ({
      id: `offer-tab-${e.offer.providerKey}-${e.offer.productType}`,
      class: [
        // Size
        "h-[75px]",
        "max-h-[75px]",
        "md:h-[68px]",
        "md:max-h-[68px]",
        "w-[132px]",
        "md:w-[320px]",
        "max-w-[320px]",
        // Padding
        "px-4",
        "py-2",
        // Makes the Tab and Tab-Body appear as a single item
        "-mb-[1px]",
        // Border
        "border",
        {
          "border-surface-300 border-b-surface-400": !e.active,
          "border-surface-400 border-b-transparent": e.active
        },
        "bg-surface-0",
        "rounded-t-2xl",
        "transition-all",
        // Layout
        "grid",
        "grid-cols-1",
        "grid-rows-[20px_1fr]",
        "md:grid-cols-2",
        "md:grid-rows-1",
        "gap-1",
        "justify-items-center"
      ]
    })), { te: o } = x(() => e.offer.providerKey), r = u(() => o(`approval-heading.${e.offer.productType}`) ? `approval-heading.${e.offer.productType}` : "approval-heading.credit"), a = De(), l = Be(async () => {
      try {
        await a.publishPlansPresented([e.offer.providerKey]);
      } catch (i) {
        Ke(i);
      }
    }, 500);
    return D(
      () => e.active,
      (i) => {
        i && l();
      }
    ), D(
      () => e.offer,
      () => {
        e.active && l();
      }
    ), (i, s) => {
      const d = C("i18n-t");
      return c(), y("button", he(ke(n.value)), [
        b(i.$slots, "logo", {}, () => [
          m(p(le), {
            role: "presentation",
            class: "logo h-max-[20px] md:h-max-[52px] h-full max-w-[112px] md:max-w-full",
            provider: t.offer.providerKey,
            vertical: t.vertical,
            "product-type": t.offer.productType
          }, null, 8, ["provider", "vertical", "product-type"])
        ], !0),
        _("div", Qe, [
          m(d, {
            keypath: r.value,
            tag: "p",
            class: "text-sm"
          }, {
            lender: v(() => [
              m(p(P), {
                "provider-key": t.offer.providerKey,
                vertical: t.vertical,
                class: "sr-only"
              }, null, 8, ["provider-key", "vertical"])
            ]),
            _: 1
          }, 8, ["keypath"]),
          t.offer.response.approvedAmountCents ? (c(), f(p(M), {
            key: 0,
            value: t.offer.response.approvedAmountCents,
            class: "text-sm font-bold md:text-2xl",
            whole: ""
          }, null, 8, ["value"])) : k("", !0)
        ])
      ], 16);
    };
  }
});
function ne(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      "approval-heading": {
        credit: { t: 0, b: { t: 2, i: [{ t: 4, k: "lender" }, { t: 3, v: ` Credit Limit:
` }] } },
        lease: { t: 0, b: { t: 2, i: [{ t: 4, k: "lender" }, { t: 3, v: ` Lease up to:
` }] } },
        loan: { t: 0, b: { t: 2, i: [{ t: 4, k: "lender" }, { t: 3, v: ` Loan up to:
` }] } }
      }
    }
  });
}
typeof ne == "function" && ne(ve);
const Ze = /* @__PURE__ */ ue(ve, [["__scopeId", "data-v-ada0654a"]]), et = {
  class: "flex flex-row gap-0.5",
  role: "tablist"
}, Yt = /* @__PURE__ */ h({
  __name: "PlanSummaryTabs",
  props: /* @__PURE__ */ V({
    offers: {},
    vertical: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = B(t, "modelValue"), o = (a) => {
      n.value = a, ge().then(() => {
        const l = document.getElementById(`tab-${a.id}`);
        l && l.focus();
      });
    }, r = (a, l) => {
      const i = e.offers.indexOf(l);
      if (i != -1) {
        if (a.key == "ArrowRight" && i < e.offers.length) {
          const s = e.offers[i + 1];
          s && o(s);
        }
        if (a.key == "ArrowLeft" && i > 0) {
          const s = e.offers[i - 1];
          s && o(s);
        }
      }
    };
    return xe(() => {
      n.value == null && e.offers.length && (n.value = e.offers[0]);
    }), (a, l) => (c(), y("div", et, [
      (c(!0), y(K, null, L(t.offers, (i) => (c(), f(Ze, {
        id: `tab-${i.id}`,
        key: `tab-${i.id}`,
        role: "tab",
        class: "cursor-pointer",
        offer: i,
        active: n.value?.id === i.id,
        vertical: t.vertical,
        "aria-selected": n.value?.id === i.id,
        "aria-controls": `tabpanel-${i.id}`,
        tabindex: n.value?.id === i.id ? 0 : -1,
        onClick: (s) => o(i),
        onKeyup: (s) => r(s, i)
      }, {
        logo: v(() => [
          b(a.$slots, "logo", { offer: i })
        ]),
        _: 2
      }, 1032, ["id", "offer", "active", "vertical", "aria-selected", "aria-controls", "tabindex", "onClick", "onKeyup"]))), 128))
    ]));
  }
}), tt = {
  key: 0,
  class: "space-y-4 p-4"
}, nt = {
  class: "flex flex-col gap-4",
  role: "radiogroup"
}, jt = /* @__PURE__ */ h({
  __name: "PlanSummaryTabBody",
  props: /* @__PURE__ */ V({
    active: { type: Boolean },
    offer: {},
    selectable: { type: Boolean },
    purchaseAmount: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = B(t, "modelValue"), o = u({
      get() {
        return n?.value?.providerPlanCode;
      },
      set(r) {
        r == null ? n.value = void 0 : n.value = e.offer.plans.find(
          (a) => a.providerPlanCode === r
        );
      }
    });
    return Ve(
      {
        selectedPlanCode: o
      },
      {
        selectedPlanCode: {
          required: Re(() => e.selectable && e.active)
        }
      }
    ), (r, a) => t.active ? (c(), y("div", tt, [
      b(r.$slots, "header", { offer: t.offer }),
      _("div", nt, [
        (c(!0), y(K, null, L(t.offer.plans, (l) => (c(), y("div", {
          key: l.providerPlanCode
        }, [
          b(r.$slots, "plan", {
            offer: t.offer,
            plan: l,
            selectable: t.selectable,
            selectedPlanCode: o.value,
            selectPlan: (i) => o.value = i
          })
        ]))), 128))
      ]),
      b(r.$slots, "footer", { offer: t.offer })
    ])) : k("", !0);
  }
}), ot = ["id", "aria-selected", "aria-label"], at = ["for"], rt = ["id", "name", "value", "aria-labelledby"], it = { class: "flex grow flex-col items-center gap-4 bg-surface-0 p-4 md:flex-row" }, lt = { class: "logo h-auto w-35 min-w-35" }, st = { class: "legal-font-size flex grow flex-col" }, ct = { class: "mb-2 font-semibold text-primary-600" }, ut = /* @__PURE__ */ h({
  __name: "PlanCard",
  props: /* @__PURE__ */ V({
    plan: {},
    vertical: {},
    selectable: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = B(t, "modelValue"), n = t, o = u(
      () => `payment-plan-${n.plan.providerKey}-${n.plan.providerPlanCode}`
    ), r = u(
      () => `${n.plan.providerKey}-${n.plan.providerPlanCode}`
    ), a = u(
      () => `${r.value}-${n.plan.providerPlanCode}`
    ), l = u(() => e.value === n.plan.providerPlanCode), i = () => {
      n.selectable && (e.value = l.value ? void 0 : n.plan.providerPlanCode);
    };
    return (s, d) => (c(), y("div", {
      id: r.value,
      key: a.value,
      "aria-selected": l.value && t.selectable,
      "aria-label": t.plan.title,
      class: F([{
        "cursor-pointer grid-cols-[max-content_1fr]": t.selectable,
        "border-surface-600 bg-surface-0": !l.value || !t.selectable,
        "border-primary-600 bg-primary-600": l.value && t.selectable
      }, "plan-card-container grid overflow-hidden rounded-md border transition-colors"]),
      onClick: i
    }, [
      t.selectable ? (c(), y("div", {
        key: 0,
        class: F([{
          "border-r-surface-600": !l.value,
          "border-r-primary-600 bg-primary-600": l.value
        }, "grid h-full flex-col items-center border-r px-1 transition-colors"])
      }, [
        _("label", { for: o.value }, [
          l.value ? (c(), f(p(q), {
            key: 0,
            icon: p(Ee),
            class: "text-surface-0",
            size: "lg"
          }, null, 8, ["icon"])) : (c(), f(p(q), {
            key: 1,
            icon: p(Fe),
            size: "lg"
          }, null, 8, ["icon"]))
        ], 8, at),
        we(_("input", {
          id: o.value,
          "onUpdate:modelValue": d[0] || (d[0] = ($) => e.value = $),
          name: o.value,
          value: t.plan.providerPlanCode,
          "aria-labelledby": r.value,
          class: "absolute opacity-0 h-0 w-0",
          type: "radio"
        }, null, 8, rt), [
          [Ce, e.value]
        ])
      ], 2)) : k("", !0),
      _("div", null, [
        b(s.$slots, "banner", { plan: t.plan }, void 0, !0),
        _("div", it, [
          _("div", lt, [
            b(s.$slots, "logo", { plan: t.plan }, () => [
              m(p(le), {
                class: "logo h-max-[20px] md:h-max-[52px] h-full max-w-[112px] md:max-w-full",
                provider: t.plan.providerKey,
                vertical: t.vertical,
                "product-type": t.plan.providerProductType
              }, null, 8, ["provider", "vertical", "product-type"])
            ], !0)
          ]),
          _("div", st, [
            b(s.$slots, "title", { plan: t.plan }, () => [
              _("p", ct, w(t.plan.title), 1)
            ], !0),
            b(s.$slots, "content", { plan: t.plan }, void 0, !0)
          ]),
          b(s.$slots, "payment", { plan: t.plan }, void 0, !0)
        ])
      ])
    ], 10, ot));
  }
}), zt = /* @__PURE__ */ ue(ut, [["__scopeId", "data-v-bc6aa52f"]]), dt = { class: "grid min-h-20 min-w-44 grid-rows-[max-content] place-content-center gap-1 text-nowrap rounded-lg bg-surface-200 px-8 py-3 text-center text-base" }, pt = /* @__PURE__ */ h({
  __name: "PlanPayment",
  props: {
    plan: {}
  },
  setup(t) {
    const e = t;
    return x(() => e.plan.providerKey), (n, o) => {
      const r = C("i18n-t");
      return c(), y("div", dt, [
        b(n.$slots, "payment", {}, () => [
          m(r, {
            keypath: "payment",
            tag: "p",
            "aria-labelledby": `${t.plan.providerPlanCode}-title ${t.plan.providerPlanCode}-paymentSuggestion`
          }, {
            value: v(() => [
              m(p(M), {
                value: t.plan.monthlyAmountCents ?? 0
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["aria-labelledby"])
        ]),
        b(n.$slots, "learnHowDrawer", { plan: t.plan })
      ]);
    };
  }
});
function oe(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      payment: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `/mo
` }] } }
    }
  });
}
typeof oe == "function" && oe(pt);
const mt = ["id"], vt = ["id"], yt = { key: 2 }, ft = /* @__PURE__ */ h({
  __name: "PlanCardAttribute",
  props: {
    attribute: {},
    plan: {}
  },
  setup(t) {
    const e = t, { t: n } = x(() => e.plan.providerKey), o = u(() => n(`attributes.${e.attribute}.label`)), r = u(
      () => e.plan[e.attribute] != null
    ), a = (s) => s === "firstPaymentDate" || s === "expireDateTime", l = (s, d, $) => n(
      `attributes.${s}.value`,
      {
        value: d
      },
      {
        plural: $
      }
    ), i = u(() => {
      const s = e.attribute, d = e.plan[s];
      return s === "apr" ? d : typeof d == "number" ? l(s, d, d) : typeof d == "string" && a(s) ? l(
        s,
        Se(d),
        Math.max(Ie(/* @__PURE__ */ new Date(), d), 0)
      ) : d;
    });
    return (s, d) => r.value ? (c(), y("div", {
      key: t.attribute,
      class: "grid grid-cols-[160px_minmax(0,1fr)] text-xs md:text-base"
    }, [
      _("p", {
        id: `${t.attribute}-label`,
        class: "font-medium"
      }, [
        b(s.$slots, "title", {}, () => [
          I(w(o.value), 1)
        ])
      ], 8, mt),
      _("p", {
        id: `${t.attribute}-value`,
        class: "place-self-start"
      }, [
        b(s.$slots, "value", {}, () => [
          t.attribute === "apr" ? (c(), f(p(fe), {
            key: 0,
            value: i.value
          }, null, 8, ["value"])) : t.attribute.includes("Cents") ? (c(), f(p(M), {
            key: 1,
            value: i.value,
            whole: !1
          }, null, 8, ["value"])) : (c(), y("span", yt, w(i.value), 1))
        ])
      ], 8, vt)
    ])) : k("", !0);
  }
});
function ae(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      attributes: {
        apr: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `APR:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `%
` }] } }
        },
        downPaymentCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Initial Payment:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        },
        durationMonths: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Term:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " Month" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: ` Months
` }] }] } }
        },
        expireDateTime: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Approval Expires:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: " (" }, { t: 4, k: "count" }, { t: 3, v: " day)" }] }, { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: " (" }, { t: 4, k: "count" }, { t: 3, v: ` days)
` }] }] } }
        },
        financedAmountCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Amount Financed:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        },
        termMonths: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Term:
` } },
          value: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " Month" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: ` Months
` }] }] } }
        },
        totalCostCents: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Total Amount:
` } },
          value: { t: 0, b: { t: 2, i: [{ t: 4, k: "value" }, { t: 3, v: `
` }] } }
        }
      }
    }
  });
}
typeof ae == "function" && ae(ft);
const bt = { key: 0 }, _t = /* @__PURE__ */ h({
  __name: "PlanDrawer",
  props: {
    plan: {}
  },
  setup(t) {
    const e = t, { t: n } = x(() => e.plan.providerKey), o = se(!1);
    function r() {
      o.value = !0;
    }
    return (a, l) => {
      const i = Ne, s = qe;
      return t.plan ? (c(), y("div", bt, [
        m(i, {
          visible: o.value,
          "onUpdate:visible": l[0] || (l[0] = (d) => o.value = d),
          position: "right",
          "block-scroll": "",
          class: "w-full max-w-[600px]"
        }, {
          header: v(() => [...l[1] || (l[1] = [
            _("p", { class: "w-full" }, null, -1)
          ])]),
          default: v(() => [
            b(a.$slots, "content", {
              plan: t.plan,
              isVisible: o.value
            })
          ]),
          _: 3
        }, 8, ["visible"]),
        m(s, {
          label: p(n)("open_label"),
          text: "",
          class: "text-nowrap !py-0",
          onClick: $e(r, ["stop"])
        }, null, 8, ["label"])
      ])) : k("", !0);
    };
  }
});
function re(t) {
  const e = t;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      open_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Learn How" } }
    }
  });
}
typeof re == "function" && re(_t);
const ie = {
  id: "default",
  steps: ["applicant", "terms", "decision"]
}, ht = {
  id: "review-and-accept-offer",
  steps: ["reviewOffer", "terms", "decision"]
}, kt = () => {
  const t = R(), e = Me(), n = ce();
  return u(() => {
    const o = n.currentProviderKey;
    return o && t.previousResponses.find(
      (a) => a.next?.provider?.providerKey === o
    )?.next?.applyMode === "prescreen" && e.fieldCount === 0 ? ht : ie;
  });
};
function gt(t, e) {
  return typeof t == "object" && !!t[e];
}
const ye = (t) => {
  const e = de(), n = R();
  return u(() => {
    const o = e.meta?.step;
    return o ? typeof o == "string" ? o : typeof o == "function" ? o(t.value.map((a) => a.id)) : n.applyMode && gt(o, n.applyMode) ? o[n.applyMode] : o["*"] : void 0;
  });
}, xt = (t) => {
  const { t: e } = t, n = kt(), o = (r) => ({
    id: r,
    label: (a) => e(`stepper.steps.${a}.label`)
  });
  return u(() => n.value.steps.map(o));
}, wt = (t) => {
  const e = ce(), n = se(0), o = ye(t);
  return D(o, (r, a) => {
    r && a && (n.value = t.value.findIndex(
      (l) => l.id === r
    ));
  }), D(
    () => e.currentProviderKey,
    () => {
      n.value = 0;
    }
  ), u(() => n.value);
}, Ct = (t) => {
  const e = wt(t), n = ye(t);
  return u(() => {
    const o = n.value;
    return o ? t.value.findIndex((r) => r.id === o) : e.value;
  });
}, Ht = (t) => {
  const e = xt(t), n = Ct(e), o = de();
  return u(() => o.meta?.hideStepper ? [] : e.value.map((r, a) => n.value === a ? {
    ...r,
    status: "active"
  } : n.value > a ? {
    ...r,
    status: "complete"
  } : {
    ...r,
    status: "inactive"
  }));
};
export {
  sn as ApplicationFooter,
  Xt as CheckDetails,
  Ot as ConfirmExitFlowButton,
  M as Currency,
  Gt as CurrencyHero,
  Jt as CurrencyPerPeriod,
  pe as DisclosureBankCard,
  S as DisclosureContact,
  me as DisclosureContactFooter,
  qt as DisclosureDictionary,
  g as DisclosureIncome,
  je as DisclosurePrequalify,
  Qt as DownloadContentButton,
  le as DynamicProviderLogo,
  Je as ErrorDetails,
  Zt as IconHero,
  en as LenderAccountName,
  E as LenderBankName,
  P as LenderName,
  Nt as ModalLauncherButton,
  fe as Percent,
  zt as PlanCard,
  ft as PlanCardAttribute,
  _t as PlanDrawer,
  pt as PlanPayment,
  jt as PlanSummaryTabBody,
  Yt as PlanSummaryTabs,
  cn as ProviderApplicationDocuments,
  tn as ProviderDecisionDataTable,
  nn as RequiredNote,
  on as TermsModal,
  mn as TermsModalLink,
  un as TermsViewer,
  dn as VersatilePrivacyPolicyLink,
  an as ViewTitle,
  rn as defineProviderDecisionTable,
  Ye as useLocalizedComponents,
  Ht as useStepperSteps
};
//# sourceMappingURL=index.es.js.map
